import React from "react";
import { Clock } from "lucide-react";
import { usePublicLanguage } from "../context/PublicLanguage";
import { readingTimeLabel } from "../lib/readingTime";
export default function ReadingTime({ article }) {
  const { language } = usePublicLanguage();
  const label = readingTimeLabel(article, language);
  return label ? <span className="inline-flex items-center gap-1" data-testid="reading-time"><Clock size={11} aria-hidden="true" />{label}</span> : null;
}
